module.exports = __webpack_public_path__ + "static/media/ThinkDigitalVRWhite.caadd0bb.png";